import '@sass/cw-table-of-contents.scss';

/* eslint-disable no-plusplus */ // putting this at the top level to bypass eslint error: 'unary operator '++' used'
/**
 * Table of Contents Plugin
 * Author Name: Consultwebs
 * Description: This is a plugin to use in our current framework
 * To exclude a heading, add a class "toc-exclude" to the heading tag
 */

export class CWTableOfContents {
    constructor(acf_toc_vars) {
        this.regexPunctuations = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
        this.regexInnerText = /(<([^>]+)>)/gi;
        this.regexLineBreaks = /\r?\n|\r/g;
        this.mainWrapper = acf_toc_vars.main_content_container;
        this.headers = document.querySelectorAll(`${this.mainWrapper} h2`);
        this.headingLevel = 1;
        this.typeTag = '';
        this.type = acf_toc_vars.type_list;
        this.location = acf_toc_vars.location;
        this.classListType = acf_toc_vars.class_of_list;
        this.column = '';
        this.width = '';
        this.widthCustom = '';
        this.viewport = acf_toc_vars.viewport;
        this.breakpoint = '';
        this.screenSize = window.matchMedia(`(min-width: ${this.viewport}px)`);
        this.headingTitle = acf_toc_vars.heading_title;
        this.sidebarContainer = acf_toc_vars.sidebar_container;
        this.mainContentContainer = acf_toc_vars.main_content_toc_container;
        this.sidebarMobileContainer = acf_toc_vars.sidebarmobile_container;
        this.exclusionList = acf_toc_vars.exclusion_list;
        this.accordionActivate = acf_toc_vars.accordion_activate;
        this.accordionSidebarActivate = acf_toc_vars.accordion_sidebar_ativate;
        this.accordionOpenDesktop = acf_toc_vars.accordion_open_desktop;
        this.accordionOpenMobile = acf_toc_vars.accordion_open_mobile;
        this.selectedCPT = acf_toc_vars.selected_cpt;
        this.activateCPTposts = acf_toc_vars.activateCPTposts;
        this.selectedTemplates = acf_toc_vars.selected_templates;
        this.activatePageTemplatePosts = acf_toc_vars.activatePageTemplatePosts;
    }


    TOCCreate() {

        //console.log('Title:' + this.headingTitle);
        if (this.type === 'Ordered List') {
            this.typeTag = 'ol';
        } else {
            this.typeTag = 'ul';
        }

        let containerListType = '';
        //console.log('Accordion: ' + this.accordionActivate);

        if (this.headers.length > 0) {
            /* searches content area for heading tags and creates the toc list */
            this.headers.forEach((heading) => {
                if (!heading.classList.contains('toc-exclude')) {
                    // check if heading does not contain class "toc-exclude"
                    const text = heading.textContent;
                    let level = heading.tagName.slice(-1);

                    let anchorHash = text
                        .toLowerCase()
                        .trim()
                        .replace(this.regexInnerText, '')
                        .replace(this.regexPunctuations, '')
                        .replace(this.regexLineBreaks, '')
                        .replace(/ /g, '-');

                    heading.id = anchorHash;

                    // hierarchical ordered list
                    if (level > this.headingLevel) {
                        containerListType += new Array(level - this.headingLevel + 1).join(
                            `<${this.typeTag} class="toc-table-list ${this.classListType}">`
                        );
                    } else if (level < this.headingLevel) {
                        containerListType += new Array(this.headingLevel - level + 1).join(
                            `</li></${this.typeTag}>`
                        );
                    } else {
                        containerListType += new Array(this.headingLevel + 1).join('</li>');
                    }

                    this.headingLevel = parseInt(level, 10);

                    // clean innerLinkNode anchors of punctuation marks and create hrefs based on heading text
                    this.anchor = text.replace(this.regexInnerText, '');
                    this.anchor = this.anchor.replace(this.regexPunctuations, '');

                    // this.anchor = this.anchor.replace(/<[^>]+>/g, '');
                    this.anchor = this.anchor.replace(/ /g, '_');
                    this.innerLinkNode = `<a href="#${anchorHash}">${text}</a>`;
                    containerListType += `<li>${this.innerLinkNode}`;
                }
            });

            /* end create toc list */

            if (this.headingLevel) {
                containerListType += new Array(this.headingLevel + 1).join(
                    `</${this.typeTag}>`
                );
            }
        }

        // assign breakpoint for bootstrap class
        if (this.viewport == '768') {
            this.breakpoint = 'md';
        } else if (this.viewport == '992') {
            this.breakpoint = 'lg';
        } else if (this.viewport == '1200') {
            this.breakpoint = 'xl';
        }

        //console.log('Selected CPT: ' + this.selectedCPT);
        //console.log('IDs under the Selected CPT: ' + this.activateCPTposts);

        var checkCheckboxValue = '';
        // Get the post ID from the body class
        const bodyClasses = document.body.classList;
        let postId = null;

        // Loop through the body classes to find the class starting with 'post-id-'
        for (let i = 0; i < bodyClasses.length; i++) {
            const bodyClass = bodyClasses[i];
            if (bodyClass.startsWith('post-id-')) {
                postId = bodyClass.replace('post-id-', '');
                break;
            }
        }

        //console.log('Selected Page Templates: ' + JSON.stringify(this.selectedTemplates));
        //console.log('IDs under the Selected Page Tempates: ' + this.activatePageTemplatePosts);

        // Check if the retrieved post ID exists in the activateCPTposts array
        if (postId && this.activateCPTposts.includes(parseInt(postId))) {
            // The post ID exists in the activateCPTposts array
            const isHomePage = document.body.classList.contains('home');
            const isErrorPage = document.body.classList.contains('error404');
            const isBlogPage = document.body.classList.contains('blog');
            const hasMainTOC = "has-main-toc";
            const body = document.querySelector('body');

            body.classList.add(hasMainTOC);

            if (!(isHomePage || isErrorPage) || isBlogPage) {
                // Page does not have body class .home or .error404, display the TOC widget
                //console.log('TOC widget should be displayed for post ID:', postId);
                if (this.location === 'Content Area') {
                    const parentContainer = document.querySelector(`${this.mainContentContainer}`); // Select the parent container using the value from acf_toc_vars.main_content_toc_container
                    const imageHolder = parentContainer.querySelector('.image-holder');
                    const titleHolder = parentContainer.querySelector('.page-title');

                    //console.log('Inside Content Area');

                    if (this.accordionActivate == 1) { //console.log('Content Accordion');
                        detectAccordion(this.screenSize, containerListType, this.headingTitle, this.location, this.breakpoint, this.sidebarContainer, this.mainContentContainer, this.sidebarMobileContainer, '', this.accordionOpenDesktop, this.accordionOpenMobile);
                        //console.log('Inside Accordion');
                        this.screenSize.addEventListener('change', () => {
                            detectAccordion(this.screenSize, containerListType, this.headingTitle, this.location, this.breakpoint, this.sidebarContainer, this.mainContentContainer, this.sidebarMobileContainer, '', this.accordionOpenDesktop, this.accordionOpenMobile);
                        });

                    } else {
                        const tocShortcode = document.createElement('div');
                        tocShortcode.className = 'toc-shortcode';

                        if (imageHolder) {
                            imageHolder.insertAdjacentElement('afterend', tocShortcode);
                        } else {
                            parentContainer.insertAdjacentElement('afterbegin', tocShortcode);
                        }

                        detectShortCode(this.screenSize, containerListType, this.headingTitle, tocShortcode.className);

                        this.screenSize.addEventListener('change', () => {
                            detectShortCode(this.screenSize, containerListType, this.headingTitle, tocShortcode.className);
                        });

                    }
                } else if (this.location === 'Sidebar') {

                    if (this.accordionSidebarActivate == 1) { //console.log('Sidebar Accordion');
                        detectAccordion(this.screenSize, containerListType, this.headingTitle, this.location, this.breakpoint, this.sidebarContainer, this.mainContentContainer, this.sidebarMobileContainer, 'hello', this.accordionOpenDesktop, this.accordionOpenMobile);

                        this.screenSize.addEventListener('change', () => {
                            detectAccordion(this.screenSize, containerListType, this.headingTitle, this.location, this.breakpoint, this.sidebarContainer, this.mainContentContainer, this.sidebarMobileContainer, 'hi', this.accordionOpenDesktop, this.accordionOpenMobile);
                        });
                    } else { //console.log('Sidebar not Accordion');
                        detectWidgetMedia(this.screenSize, containerListType, this.location, this.breakpoint, this.headingTitle, this.sidebarContainer, this.sidebarMobileContainer);
                        // listens to changes (ie orientationChange, screen resize)
                        this.screenSize.addEventListener('change', () => {
                            detectWidgetMedia(this.screenSize, containerListType, this.location, this.breakpoint, this.headingTitle, this.sidebarContainer, this.sidebarMobileContainer);
                        });
                    }
                }
            }
        } else {
            // The post ID does not exist in the activateCPTposts array
            //console.log('Eligible for Shortcode:', postId);

            // double checking if a shortcode [table-of-contents] already exists and check if the TOC widget exists on the page
            const existingTOCShortcodeWidget = document.querySelector('.toc-shortcode');
            const existingTOCAccordionWidget = document.querySelector('.toc-accordion');
            const existingTOCAccordionMobileWidget = document.querySelector('.toc-accordion-mobile');
            const existingTOCSidebarAccordionWidget = document.querySelector('.sidebar-toc-accordion');
            const existingTOCSidebarWidget = document.querySelector('.sidebar-toc');
            const tocList = document.querySelector('.toc-table-list');


            if (existingTOCShortcodeWidget || existingTOCAccordionWidget || existingTOCAccordionMobileWidget || existingTOCSidebarWidget || existingTOCSidebarAccordionWidget) {
                this.tocWidgetExists = true;
            } else {
                this.tocWidgetExists = false;
            }

            if (!this.tocWidgetExists) { // console.log('No TOC on page found');

                const tocShortcodeType = 'toc-shortcode-custom';
                const tocAccordionType = 'toc-accordion-custom';

                if (document.querySelector('.toc-shortcode-custom')) {
                    detectShortCode(this.screenSize, containerListType, this.headingTitle, tocShortcodeType);
                } else if (document.querySelector('.toc-accordion-custom')) {
                    detectAccordion(this.screenSize, containerListType, this.headingTitle, this.location, this.breakpoint, this.sidebarContainer, this.mainContentContainer, this.sidebarMobileContainer, tocAccordionType, this.accordionOpenDesktop, this.accordionOpenMobile);
                }

            }
        }

        //console.log("Breakpoint: " + this.breakpoint);
        function detectWidgetMedia(e, containerListType, location, breakpoint, headingTitle, sidebarContainer, sidebarMobileContainer) {
            /* start widget code */

            if (e.matches) {
                // if screen/device size is equal or more than breakpoint
                //console.log('desktop');
                if (
                    containerListType.length != 0 &&
                    !document.querySelector('.sidebar-toc')
                ) {
                    // check if toc list is not empty and class .sidebar-toc doesn't exist yet
                    // proceed with create toc sidebar item for sidebar
                    const sidebarItem = document.createElement('div');
                    sidebarItem.setAttribute(
                        'class',
                        `sidebar-item sidebar-toc d-none d-${breakpoint}-block`
                    );

                    const tocWidget = document.createElement('div');
                    tocWidget.setAttribute('class', 'toc');
                    tocWidget.setAttribute('id', 'toc');
                    tocWidget.innerHTML = `<div class="sidebar-title uppercase text-center">${headingTitle}</div>${containerListType}`;

                    sidebarItem.appendChild(tocWidget);

                    //console.log('sidebarContainer: ' + sidebarContainer);
                    var sidebar = document.querySelector(`${sidebarContainer}`);
                    if (sidebar) {
                        sidebar.insertBefore(sidebarItem, sidebar.childNodes[0]);
                    }
                }

            } else {
                // if screen/device size is lesser than viewport width
                //console.log('mobile');
                if (
                    containerListType.length != 0 &&
                    !document.querySelector('.sidebar-toc-mobile')
                ) {
                    // check if toc list is not empty
                    // creation of sidebar item
                    const sidebarItem = document.createElement('div');
                    sidebarItem.setAttribute(
                        'class',
                        `sidebar-item sidebar-toc-mobile d-block d-${breakpoint}-none`
                    );

                    const tocWidget = document.createElement('div');
                    tocWidget.setAttribute('class', 'float-lg-start toc sidebar-widget');
                    tocWidget.setAttribute('id', 'toc');
                    tocWidget.innerHTML = `<div class="sidebar-title uppercase text-center">${headingTitle}</div>${containerListType}`;

                    sidebarItem.appendChild(tocWidget);
                    //console.log(sidebarItem);

                    //console.log('sidebarMobileContainer: ' + sidebarMobileContainer);
                    var imageHolder = document.querySelector(`${sidebarMobileContainer} .image-holder`);
                    var sidebarMobile = document.querySelector(`${sidebarMobileContainer}`);

                    if (sidebarMobile && imageHolder) {
                        // Insert sidebarItem after the first .image-holder element
                        imageHolder.parentNode.insertBefore(sidebarItem, imageHolder.nextSibling);
                    } else if (sidebarMobile) {
                        sidebarMobile.insertBefore(sidebarItem, sidebarMobile.childNodes[0]);
                    }
                }
            } /* end widget code */
        }

        function detectShortCode(e, containerListType, headingTitle, tocShortcodeType) {
            // The query selector now uses tocShortcodeType variable
            const shortcodeContainer = document.querySelector(`.${tocShortcodeType}`);

            if (shortcodeContainer) {
                if (containerListType.length != 0) {
                    const tocShortcode = document.createRange().createContextualFragment(`<div class="toc sidebar-widget" >
                <div class="sidebar-title uppercase text-center">${headingTitle}</div>
                ${containerListType} </div>
                `);

                    let cloneTOC = '';

                    cloneTOC = tocShortcode.cloneNode(true);
                    shortcodeContainer.appendChild(cloneTOC);
                }
            }
        }

        function detectAccordion(e, containerListType, headingTitle, location, breakpoint, sidebarContainer, mainContentContainer, sidebarMobileContainer, tocAccordionClass, openDesktop, openMobile) {
            // console.log('accordion function partial file called');

            const openByDefault = e.matches ? openDesktop == 1 : openMobile == 1;
            const checkedAttr = openByDefault ? ' checked' : '';

            const tocAccordionContent = document.createRange().createContextualFragment(`<div class="accordion-tab-wrapper">
      <div class="accordion-tab">
      <input type="checkbox" id="accordion-check"${checkedAttr}>
      <label class="tab-label" for="accordion-check">${headingTitle}</label>
      <div class="tab-content">
      <div class="tab-content-inner">
      ${containerListType} 
      </div>
      </div>
      </div> 
      </div>
      `);

            const cloneTOC = tocAccordionContent.cloneNode(true);
            const AccordionShortcode = document.querySelector('.toc-accordion-custom');
            const tocAccordion = document.querySelector('.toc-accordion');
            const tocAccordionMobile = document.querySelector('.toc-accordion-mobile');
            const tocSidebarAccordion = document.querySelector('.sidebar-toc-accordion');
            const hasMainTOC = document.querySelector('.has-main-toc');

            if (hasMainTOC) {
                if (e.matches) {
                    const sidebarMobile = document.querySelector('.toc-accordion-mobile');
                    if (sidebarMobile) {
                        while (sidebarMobile.firstChild) {
                            sidebarMobile.removeChild(sidebarMobile.firstChild);
                        }
                    }

                    if (location === "Sidebar") {
                        if (containerListType.length != 0 && !document.querySelector('.sidebar-toc-accordion')) {

                            if (tocAccordion != 'toc-accordion-custom') {
                                const sidebar = document.querySelector(`${sidebarContainer}`);
                                if (sidebar) {
                                    const sidebarItem = document.createElement('div');
                                    sidebarItem.setAttribute(
                                        'class',
                                        `sidebar-toc-accordion d-none d-${breakpoint}-block`
                                    );
                                    sidebarItem.appendChild(cloneTOC);
                                    sidebar.insertBefore(sidebarItem, sidebar.childNodes[0]);
                                }
                            }
                        }
                    }
                } else {

                    if (location === "Sidebar") {
                        if (containerListType.length != 0) { //console.log('mobile accordion');

                            if (!document.querySelector('.toc-accordion-mobile')) {
                                const sidebarMobile = document.querySelector(`${sidebarMobileContainer}`);

                                if (sidebarMobile) {
                                    const sidebarMobileItem = document.createElement('div');
                                    sidebarMobileItem.setAttribute(
                                        'class',
                                        `toc-accordion-mobile d-block d-${breakpoint}-none`
                                    );
                                    sidebarMobileItem.appendChild(cloneTOC);
                                    sidebarMobile.insertBefore(sidebarMobileItem, sidebarMobile.childNodes[0]);

                                    const imageHolder = document.querySelector(`${sidebarMobileContainer} .image-holder`);
                                    const titleHolder = document.querySelector(`${sidebarMobileContainer} .page-title`);

                                    if (sidebarMobile && imageHolder) {
                                        imageHolder.parentNode.insertBefore(sidebarMobileItem, imageHolder.nextSibling);
                                    } else if (sidebarMobile && titleHolder) {
                                        titleHolder.parentNode.insertBefore(sidebarMobileItem, titleHolder.nextSibling);
                                    } else if (sidebarMobile) {
                                        sidebarMobile.insertBefore(sidebarMobileItem, sidebarMobile.childNodes[0]);
                                    }
                                }
                            } else {
                                let sidebarMobile = document.querySelector('.toc-accordion-mobile');

                                if (sidebarMobile) {
                                    let imageHolder = sidebarMobile.querySelector('.image-holder');
                                    let pageTitle = sidebarMobile.querySelector('.page-title');

                                    if (imageHolder) {
                                        // If 'image-holder' is present, append after it
                                        imageHolder.insertAdjacentElement('afterend', cloneTOC);
                                        //console.error('Appended after .image-holder inside existing .toc-accordion-mobile');
                                    } else if (pageTitle) {
                                        // If 'page-title' is present, append after it
                                        pageTitle.insertAdjacentElement('afterend', cloneTOC);
                                        //console.error('Appended after .page-title inside existing .toc-accordion-mobile');
                                    } else {
                                        // If none of them are present, do nothing or log a message
                                        document.querySelector('.toc-accordion-mobile').appendChild(cloneTOC);
                                        // console.error('Neither .image-holder nor .page-title found inside existing .toc-accordion-mobile');
                                    }
                                }
                            }
                        }
                    }
                }

                if (location === "Content Area") { //console.log('Location Content Area and Content Area Accordion Activated');
                    if (containerListType.length != 0 && !document.querySelector('.toc-accordion')) {
                        const mainContent = document.querySelector(`${mainContentContainer}`);

                        if (mainContent) {
                            let imageHolder = mainContent.querySelector('.image-holder');
                            let pageTitle = mainContent.querySelector('.page-title');
                            const sidebarMobileItem = document.createElement('div');

                            sidebarMobileItem.setAttribute(
                                'class',
                                `toc-accordion`
                            );
                            sidebarMobileItem.appendChild(cloneTOC);

                            if (imageHolder) { // If 'image-holder' is present, append after it
                                imageHolder.insertAdjacentElement('afterend', sidebarMobileItem);
                            } else if (pageTitle) { // If 'page-title' is present, append after it
                                pageTitle.insertAdjacentElement('afterend', sidebarMobileItem);
                            } else { // If none of them are present, add as the first child of mainContent
                                mainContent.insertBefore(sidebarMobileItem, mainContent.childNodes[0]);
                            }
                        }
                    }
                }
            } else {
                //console.error('Shortcode Proper');
                const manualAccordionShortcode = document.querySelector('.toc-accordion-custom');

                if (manualAccordionShortcode) {
                    manualAccordionShortcode.appendChild(cloneTOC);
                }
            }
        }

        // remove appended hash in the url for every clicked linkTag in TOC
        window.addEventListener('hashchange', () => {
            window.history.replaceState(null, null, ' ');
        });

    }

    TOCColumnLayout() { //console.log('inside TOCColumnLayout function');

        this.containerList = document.querySelector('.toc-shortcode');
        this.containerListAccordion = document.querySelector('.toc-accordion');
        this.containerShortcodeList = document.querySelector('.toc-shortcode-custom');
        this.containerShortcodeListAccordion = document.querySelector('.toc-accordion-custom');

        if (this.containerShortcodeList || this.containerShortcodeListAccordion) {
            if (!this.containerList && !this.containerListAccordion && (this.containerShortcodeList || this.containerShortcodeListAccordion)) {

                if (typeof shortcodeValue !== 'undefined') {
                    if (!shortcodeValue.columns) { // if no column attribute
                        this.column = acf_toc_vars.column_layout; //console.log('layout general: ' + this.column);
                    } else { // if column attribute is present
                        this.column = shortcodeValue.columns; //console.log('layout shortcode: ' + this.column);
                    } //console.error('no main TOC present. column layout is from shortcode attributes');
                }
            } else {
                this.column = acf_toc_vars.column_layout;
                //console.error('main TOC present. column layout is from Options');
            }

        } else { // if no shortcode exists, use general setting
            this.column = acf_toc_vars.column_layout; //console.log('No shortcode');
        }

        if (this.containerList || this.containerListAccordion || this.containerShortcodeList || this.containerShortcodeListAccordion) {
            detectLayout(this.screenSize, this.column, this.containerList, this.containerListAccordion, this.containerShortcodeList, this.containerShortcodeListAccordion);

            // listens to changes (ie orientationChange, screen resize)
            this.screenSize.addEventListener('change', () => {
                detectLayout(this.screenSize, this.column, this.containerList, this.containerListAccordion, this.containerShortcodeList, this.containerShortcodeListAccordion);
            });
        }

        // Changes column layout based on radio button value set in TOC Options page
        function detectLayout(e, tocColumn, ...containers) {
            //console.log('inside detectLayout, e.matches: ', e.matches, ', tocColumn: ', tocColumn);

            if (containers.some(container => container !== null)) {
                if (e.matches) {
                    const columns = tocColumn === 'columns-two' ? ['columns-two', 'columns-one'] : ['columns-one', 'columns-two'];
                    containers.forEach(container => updateContainerClass(container, columns[0], columns[1]));
                    //console.log(`Columns: ${columns[0]}`);
                } else {
                    containers.forEach(container => updateContainerClass(container, 'columns-one', 'columns-two'));
                }
            }
        }

        function updateContainerClass(container, classToAdd, classToRemove) {
            if (container) {
                container.classList.add(classToAdd);
                container.classList.remove(classToRemove);
            }
        }
    }


    TOCWidth() { //console.log('inside TOCWidth function');
        this.containerList = document.querySelector('.toc-shortcode');
        this.containerListAccordion = document.querySelector('.toc-accordion');
        this.containerShortcodeList = document.querySelector('.toc-shortcode-custom');
        this.containerShortcodeListAccordion = document.querySelector('.toc-accordion-custom');

        if (this.containerShortcodeList || this.containerShortcodeListAccordion) {
            if (!this.containerList && !this.containerListAccordion && (this.containerShortcodeList || this.containerShortcodeListAccordion)) {
                if (typeof shortcodeValue !== 'undefined') {
                    if ((this.containerShortcodeList && (shortcodeValue.widthtype == 'custom' && shortcodeValue.widthvalue)) ||
                        (this.containerShortcodeListAccordion && (shortcodeValue.widthtype == 'custom' && shortcodeValue.widthvalue))) {
                        this.width = 'custom';
                        this.widthCustom = shortcodeValue.widthvalue;
                    } else if ((this.containerShortcodeList && shortcodeValue.widthtype == 'full') ||
                        (this.containerShortcodeListAccordion && shortcodeValue.widthtype == 'full')) {
                        this.width = 'full';
                        this.widthCustom = '100%';
                    } else {
                        this.width = acf_toc_vars.width;
                        this.widthCustom = acf_toc_vars.custom_width;
                    }
                    //console.error('no main TOC present. width is from shortcode attributes');
                } else {
                    this.width = acf_toc_vars.width;
                    this.widthCustom = acf_toc_vars.custom_width;
                }
            } else {
                this.width = acf_toc_vars.width;
                this.widthCustom = acf_toc_vars.custom_width;
            }

        } else { // if no shortcode exists, use general settings
            this.width = acf_toc_vars.width;
            this.widthCustom = acf_toc_vars.custom_width;
        }

        //console.log(this.width + ' Width');
        //console.log(this.widthCustom + ' Width Custom');

        if (this.containerList || this.containerListAccordion || this.containerShortcodeList || this.containerShortcodeListAccordion) {
            detectWidth(this.screenSize, this.width, this.widthCustom, this.containerList, this.containerListAccordion, this.containerShortcodeList, this.containerShortcodeListAccordion);
            // listens to changes (ie orientationChange, screen resize)
            this.screenSize.addEventListener('change', () => {
                detectWidth(this.screenSize, this.width, this.widthCustom, this.containerList, this.containerListAccordion, this.containerShortcodeList, this.containerShortcodeListAccordion);
            });
        }

        // changes toc width according to radio button value in site options
        function detectWidth(e, tocwidth, tocWidthCustom, containerList, containerListAccordion, containerShortcodeList, containerShortcodeListAccordion) {
            if (e.matches) {
                // remove class 'width-full' if transitioning to and from desktop and mobile breakpoints
                if (containerList) {
                    containerList.classList.contains('width-full') ? containerList.classList.remove('width-full') : '';
                    containerList.classList.contains('width-custom') ? containerList.classList.remove('width-custom') : '';
                    containerList.classList.contains(`width-${tocWidthCustom}px`) ? containerList.classList.remove(`width-${tocWidthCustom}px`) : '';
                    document.querySelector('.toc-shortcode .toc') ? document.querySelector('.toc-shortcode .toc').removeAttribute('style') : '';
                }

                if (containerListAccordion) {
                    containerListAccordion.classList.contains('width-full') ? containerListAccordion.classList.remove('width-full') : '';
                    containerListAccordion.classList.contains('width-custom') ? containerListAccordion.classList.remove('width-custom') : '';
                    containerListAccordion.classList.contains(`width-${tocWidthCustom}px`) ? containerListAccordion.classList.remove(`width-${tocWidthCustom}px`) : '';
                    document.querySelector('.toc-accordion') ? document.querySelector('.toc-accordion').removeAttribute('style') : '';
                }

                if (containerShortcodeList) {
                    containerShortcodeList.classList.contains('width-full') ? containerShortcodeList.classList.remove('width-full') : '';
                    containerShortcodeList.classList.contains('width-custom') ? containerShortcodeList.classList.remove('width-custom') : '';
                    containerShortcodeList.classList.contains(`width-${tocWidthCustom}px`) ? containerShortcodeList.classList.remove(`width-${tocWidthCustom}px`) : '';
                    document.querySelector('.toc-shortcode-custom') ? document.querySelector('.toc-shortcode-custom').removeAttribute('style') : '';
                }

                if (containerShortcodeListAccordion) {
                    containerShortcodeListAccordion.classList.contains('width-full') ? containerShortcodeListAccordion.classList.remove('width-full') : '';
                    containerShortcodeListAccordion.classList.contains('width-custom') ? containerShortcodeListAccordion.classList.remove('width-custom') : '';
                    containerShortcodeListAccordion.classList.contains(`width-${tocWidthCustom}px`) ? containerShortcodeListAccordion.classList.remove(`width-${tocWidthCustom}px`) : '';
                    document.querySelector('.toc-accordion-custom') ? document.querySelector('.toc-accordion-custom').removeAttribute('style') : '';
                }

                //console.log('tocwidth:' + tocwidth); console.log('tocwidthCustom:' + tocWidthCustom);
                if (document.querySelector('.toc-shortcode .toc')) {
                    // if screen/device size is equal or more than breakpoint
                    if (tocwidth === 'custom') {
                        containerList.classList.add('width-custom');

                        containerList.classList.add(`width-${tocWidthCustom}`);
                        document.querySelector('.toc-shortcode .toc').style = `float: left!important; margin-right:50px;`;
                        document.querySelector('.toc-shortcode .toc').style.width = `${tocWidthCustom}px`;

                        // if shortcode is used in sidebar
                        if (document.querySelector('.sidebar .toc-shortcode .toc')) { //console.log('sidebar toc shortcode');
                            document.querySelector('.toc-shortcode .toc').style = 'width: inherit; float: none; margin-right: 0;';
                        }

                    } else if (tocwidth === 'full') {
                        containerList.classList.add('width-full');
                        document.querySelector('.toc-shortcode .toc').style.width = '100%';
                    }
                } else if (document.querySelector('.toc-accordion')) {
                    // if screen/device size is equal or more than breakpoint
                    if (tocwidth === 'custom') {
                        containerListAccordion.classList.add('width-custom');
                        containerListAccordion.classList.add(`width-${tocWidthCustom}`);
                        document.querySelector('.toc-accordion').style = `display: block`;
                        document.querySelector('.toc-accordion').style.width = `${tocWidthCustom}px`;

                        // if shortcode is used in sidebar
                        if (document.querySelector('.sidebar .toc-accordion')) { //console.log('sidebar toc shortcode');
                            document.querySelector('.toc-accordion').style = 'width: inherit; float: none; margin-right: 0;';
                        }

                    } else if (tocwidth === 'full') {
                        document.querySelector('.toc-accordion').classList.add('width-full');
                        document.querySelector('.toc-accordion').style.width = '100%';
                    }
                }

                //console.log('tocwidth:' + tocwidth); console.log('tocwidthCustom:' + tocWidthCustom);
                if (document.querySelector('.toc-shortcode-custom .toc')) {
                    // if screen/device size is equal or more than breakpoint
                    if (tocwidth === 'custom') {
                        containerShortcodeList.classList.add('width-custom');
                        containerShortcodeList.classList.add(`width-${tocWidthCustom}`);
                        document.querySelector('.toc-shortcode-custom .toc').style = `float: left!important; margin-right:50px;`;
                        document.querySelector('.toc-shortcode-custom .toc').style.width = `${tocWidthCustom}px`;

                        // if shortcode is used in sidebar
                        if (document.querySelector('.sidebar .toc-shortcode-custom .toc')) { //console.log('sidebar toc shortcode');
                            document.querySelector('.toc-shortcode-custom .toc').style = 'width: inherit; float: none; margin-right: 0;';
                        }

                    } else if (tocwidth === 'full') {
                        containerShortcodeList.classList.add('width-full');
                        document.querySelector('.toc-shortcode-custom .toc').style.width = '100%';
                    }
                } else if (document.querySelector('.toc-accordion-custom')) {
                    // if screen/device size is equal or more than breakpoint
                    if (tocwidth === 'custom') {
                        containerShortcodeListAccordion.classList.add('width-custom');
                        containerShortcodeListAccordion.classList.add(`width-${tocWidthCustom}`);
                        document.querySelector('.toc-accordion-custom').style = `display: block`;
                        document.querySelector('.toc-accordion-custom').style.width = `${tocWidthCustom}px`;

                        // if shortcode is used in sidebar
                        if (document.querySelector('.sidebar .toc-accordion-custom')) { //console.log('sidebar toc shortcode');
                            document.querySelector('.toc-accordion-custom').style = 'width: inherit; float: none; margin-right: 0;';
                        }

                    } else if (tocwidth === 'full') {
                        containerShortcodeListAccordion.classList.add('width-full');
                        document.querySelector('.toc-accordion-custom').style.width = '100%';
                    }


                }
            } else { // if screen/device size is lesser than breakpoint

                if (containerList) {
                    containerList.classList.contains(`width-${tocwidth}`) ? containerList.classList.remove(`width-${tocwidth }`) : '';
                    containerList.classList.contains(`width-${tocWidthCustom}px`) ? containerList.classList.remove(`width-${tocWidthCustom}px`) : '';
                }

                if (containerListAccordion) {
                    containerListAccordion.classList.contains(`width-${tocwidth}`) ? containerListAccordion.classList.remove(`width-${tocwidth }`) : '';
                    containerListAccordion.classList.contains(`width-${tocWidthCustom}px`) ? containerListAccordion.classList.remove(`width-${tocWidthCustom}px`) : '';
                }

                if (document.querySelector('.toc-shortcode .toc')) {
                    containerList.classList.add('width-full');
                    document.querySelector('.toc-shortcode .toc').style = 'width: inherit; float: none;';
                }

                if (document.querySelector('.toc-accordion')) {
                    document.querySelector('.toc-accordion').classList.add('width-full');
                    document.querySelector('.toc-accordion').style = 'width: inherit; float: none;';
                }
            }

        }
    }
}

// faq elements exclusion
// add .toc-exclude class to faq section heading tags.
const faqTitles = document.querySelectorAll('.qa-faq-title');
const faqHeading = document.querySelector('.faq-catname');

faqTitles.forEach(title => {
    title.classList.add('toc-exclude');
});

if (faqHeading) {
    faqHeading.classList.add('toc-exclude');
}

// Detects pages from Exclusion List and hides TOC if body class matches
const separatedExcludeClasses = acf_toc_vars.exclusion_list.split(',');
const arrayLength = separatedExcludeClasses.length;
let excludeFlag = false;

for (let i = 0; i < arrayLength; i++) {
    separatedExcludeClasses[i] = separatedExcludeClasses[i].replace(/\s+/g, '');

    if (separatedExcludeClasses[i]) {
        const bodyClass = document.querySelector(separatedExcludeClasses[i]);
        if (bodyClass) {
            excludeFlag = true;
        }
    }
}


if (!excludeFlag) {
    const cwTOC = new CWTableOfContents(acf_toc_vars);
    cwTOC.TOCCreate();

    const shortcodeElement = document.querySelector('.toc-shortcode');
    const accordionElement = document.querySelector('.toc-accordion');
    const accordionElementMobile = document.querySelector('.toc-accordion-mobile');
    const shortcodeContentElement = document.querySelector('.toc-shortcode-custom');
    const accordionContentElement = document.querySelector('.toc-accordion-custom');

    if (shortcodeElement || shortcodeContentElement || accordionElement || accordionContentElement || accordionElementMobile) {
        cwTOC.TOCColumnLayout();
        cwTOC.TOCWidth();
    }
} else {
    if (document.querySelector('.toc-shortcode')) {
        document.querySelector('.toc-shortcode').outerHTML = '';
    }

    if (document.querySelector('.toc-accordion')) {
        document.querySelector('.toc-accordion').outerHTML = '';
    }
}